import { useGlobalState } from "@services/useGlobalState";

export const useAppGroupId = (): string => {
  const { currentAppGroupId } = useGlobalState();

  if (!currentAppGroupId) {
    throw new Error("No app group ID");
  }

  return currentAppGroupId;
};
